import { useAbility } from "@casl/react";
import { Card, IconButton, Tooltip } from "@mui/material";
import { AbilityContext } from "Can";
import MDAlert from "components/MDAlert";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import CrudService from "services/cruds-service";
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'


const CampaignAssociationList = () => {
  let { state } = useLocation();
  const ability = useAbility(AbilityContext);
  const [data, setData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [notification, setNotification] = useState({
    value: false,
    text: "",
  });
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        setLoader(true);
        const response = await CrudService.getAllCampaignAssociation();
        setData(response.data);
        setLoader(false);
      } catch (error) {
        console.error("error", error);
        setLoader(false);
      }
    })();
    document.title = `Rivio | Campaign | Contact`;
  }, []);

  useEffect(() => {
    if (!state) return;
    setNotification({
      value: state.value,
      text: state.text,
    });
  }, [state]);

  useEffect(() => {
    if (notification.value === true) {
      let timer = setTimeout(() => {
        setNotification({
          value: false,
          text: "",
        });
      }, 5000);
    }
  }, [notification]);

  useEffect(() => {
    setTableData(getRows(data));
  }, [data]);

  const getRows = (info) => {
    let updatedInfo = info.map((row) => {
      return {
        id: row.uuid,
        uuid: row.uuid,
        campaign_id: row.campaign_id,
        company_id: row.company_id,
        campaign_name: row?.Campaign?.name,
        company_name: row?.CampaignCompany?.company_name,
      };
    });
    return updatedInfo;
  };

  const dataTableData = {
    columns: [
      { Header: "UUID", accessor: "uuid" },
      { Header: "Campaign Id", accessor: "campaign_id" },
      { Header: "Company Id", accessor: "company_id" },
      { Header: "Campaign Name", accessor: "campaign_name" },
      { Header: "Company Name", accessor: "company_name" },
      {
        Header: "actions",
        disableSortBy: true,
        accessor: "",
        Cell: (info) => {
          return (
            <MDBox display="flex" alignItems="center">
              {ability.can("edit", "campaign") && (
                <Tooltip title="Edit Association">
                  <IconButton
                    onClick={() => clickEditHandler(info.cell.row.original.id)}
                  >
                    <MDTypography>
                      <EditIcon />
                    </MDTypography>
                  </IconButton>
                </Tooltip>
              )}

              {ability.can("delete", "campaign") && (
                <Tooltip title="Delete Association">
                  <IconButton
                    onClick={(e) =>
                      clickDeleteHandler(e, info.cell.row.original.id)
                    }
                  >
                    <MDTypography>
                      <DeleteIcon />
                    </MDTypography>
                  </IconButton>
                </Tooltip>
              )}
            </MDBox>
          );
        },
      },
    ],

    rows: tableData,
  };

  const clickAddHandler = () => {
    navigate("/campaign/association/new");
  };

  const clickEditHandler = async (id) => {
    navigate(`/campaign/association/edit/${id}`);
  };

  const clickDeleteHandler = async (e, id) => {
    try {
      if (!confirm("Are you sure you want to delete this Association?")) {
        e.nativeEvent.stopImmediatePropagation();
      } else {
        setLoader(true);
        await CrudService.removeCampaignAssociation(id);
        const response = await CrudService.getAllCampaignAssociation();
        setData(response.data);
        setNotification({
          value: true,
          text: "The Association has been successfully deleted",
        });
        setLoader(false);
      }
    } catch (err) {
      console.error(err);
      if (err.hasOwnProperty("msg")) {
        setNotification({
          value: true,
          text: err.msg,
        });
      }
      setLoader(false);
      return null;
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {notification.value && (
        <MDAlert color="info" my="20px">
          <MDTypography variant="body2" color="white">
            {notification.text || ""}
          </MDTypography>
        </MDAlert>
      )}
      <MDBox pt={1}>
        <MDBox>
          <Card>
            <MDBox
              p={3}
              lineHeight={1}
              display="flex"
              justifyContent="space-between"
            >
              <MDTypography variant="h5" fontWeight="medium">
                Campaign Association
              </MDTypography>
              {ability.can("create", "campaign") && (
                <MDButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  type="submit"
                  onClick={clickAddHandler}
                >
                  + Add Association
                </MDButton>
              )}
            </MDBox>

            <DataTable
              table={dataTableData}
              canSearch={true}
              tableHeight="calc(100vh - 220px)"
              loader={loader}
            />
          </Card>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default CampaignAssociationList;
